<script setup>
import { onMounted, ref } from "vue";

// Виджет записи ВКонтакте (VK.Widgets.Post) — для встраивания клипа/видео из поста.
// Принимает уже распарсенные owner_id, post_id и hash (hash обязателен для VK).
const props = defineProps({
  ownerId: { type: Number, required: true },
  postId: { type: Number, required: true },
  hash: { type: String, default: "" },
});

const containerId = `vk_post_${props.ownerId}_${props.postId}`;
const ready = ref(false);

function initWidget() {
  if (typeof VK === "undefined" || !props.ownerId || !props.postId) return;
  ready.value = true;
  // Контейнер должен существовать в DOM до вызова — ставим в nexttick через ready+таймаут 0
  setTimeout(() => {
    try {
      VK.Widgets.Post(containerId, props.ownerId, props.postId, props.hash);
    } catch (e) { /* виджет недоступен — остаётся фолбэк-ссылка */ }
  }, 0);
}

onMounted(() => {
  if (!props.ownerId || !props.postId) return;

  if (typeof VK !== "undefined") {
    initWidget();
    return;
  }

  // Ленивая загрузка openapi.js — как в VKwidjet.vue
  const existing = document.querySelector('script[src*="vk.com/js/api/openapi.js"]');
  if (existing) {
    existing.addEventListener("load", initWidget);
  } else {
    const s = document.createElement("script");
    s.src = "https://vk.com/js/api/openapi.js?173";
    s.async = true;
    s.onload = initWidget;
    document.head.appendChild(s);
  }
});
</script>

<template>
  <div class="my-6">
    <div v-if="ready" :id="containerId"></div>
    <a v-else :href="`https://vk.com/wall${ownerId}_${postId}`" target="_blank" rel="noopener"
      class="block text-sm text-indigo-600 hover:underline py-2">
      Смотреть видео ВКонтакте →
    </a>
  </div>
</template>
